import React from 'react';
import SVGComponent from '../../../components/SVG/SVGComponent';
import { SVG_ICONS } from '../../../constants';

const ApproveAndCancelIcons = (props) => (
  <div className="action-wrap">
    <div
      className="action__btn action__btn--approve"
      onClick={props.requestForUpdate}
    >
      <SVGComponent
        src={`${SVG_ICONS.utility}#tick1`}
      />
    </div>
    <div
      className="action__btn action__btn--cancel"
      onClick={props.closeConfirmationBtns}
    >
      <SVGComponent
        src={`${SVG_ICONS.utility}#close-w`}
      />
    </div>
  </div>
);
export default ApproveAndCancelIcons;
